import React from 'react';
import './header.scss';
import { Link } from 'react-router-dom';

class Header extends React.Component<any> {
  headerRef: React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props:any) {
    super(props);
    this.state = { date: new Date() };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.runOnScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.runOnScroll);
  }

  getNavLink(data: any) {
    if (data.redirectTo) {
      return data.redirectTo;
    }

    const normalized = data.name?.toLowerCase().trim();
    if (normalized === 'resume' || normalized === 'resumes') {
      return '/#resumes';
    }
    if (normalized === 'portfolio') {
      return '/#portfolio';
    }
    if (normalized === 'contact') {
      return '/#contacts';
    }
    return '/#' + normalized?.replace(/\s+/g, '-') || '/';
  }

  handleNavClick = (event: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    const hashIndex = target.indexOf('#');
    if (hashIndex === -1) {
      return;
    }

    const id = target.slice(hashIndex + 1);
    const targetEl = document.getElementById(id);
    if (targetEl) {
      event.preventDefault();
      targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  runOnScroll = () => {
    const navbarElement = this.headerRef.current;
    if (!navbarElement) {
      return;
    }

    const scrollTop = document.documentElement.scrollTop || window.scrollY;
    if (scrollTop > 0) {
      navbarElement.classList.add('header__sticky');
    } else {
      navbarElement.classList.remove('header__sticky');
    }
  }

  render() {
    const headerData = this.props.header || [];

    return (
      <div className='header'>
        <div className='header__navbar' ref={this.headerRef} id='navbar'>
          <div className='container'>
            {headerData.map((data: any, index:number) => {
              const link = this.getNavLink(data);
              return (
                <Link
                  className='header__navbar--item resume'
                  to={link}
                  key={index}
                  onClick={(event) => this.handleNavClick(event, link)}
                >
                  {data.name}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Header;